import { render, staticRenderFns } from "./ComLoginForm.vue?vue&type=template&id=26c1f4bc&"
import script from "./ComLoginForm.vue?vue&type=script&lang=js&"
export * from "./ComLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports